module.exports = __webpack_public_path__ + "img/forgot-password-v2-dark.1a16bdc1.svg";